<form [formGroup]="newGameAssetsSettingsForm" (change)="onFormChange()">

  <small>*The Following images are for display only. These images will need to be uploaded into AZURE in order for the
    game to display them.</small>

  <div class="margin-top-med">
    <div class="text-underline">QR Code Image:</div>
    @if (qrCodeImageState === CreateImageState.ViewSavedImage) {
      <img [src]="this.assetManagementService.qrCodeImageUrl" alt="Uploaded Image" style="max-width: 300px;"/>
      <div>
        <button color="primary" mat-raised-button (click)="editQRCode()" data-testid="confirm-game">
          Change QR Code
        </button>
      </div>

    } @else if (qrCodeImageState === CreateImageState.NoImageSaved) {
      <input type="file"
             accept=".png"
             class="file-input display-none"
             (change)="onQrCodeFileSelected($event)" #qrfileUpload>
      @if (this.assetManagementService.qrCodeImage) {
        <div class="margin-top-med margin-bottom-med">
          <img [src]="this.assetManagementService.qrCodeImageUrl" alt="Uploaded Image" style="max-width: 300px;"/>
        </div>
      }
      <div class="margin-top-med">
        <button color="primary" mat-raised-button
                (click)="qrfileUpload.click()">
          <mat-icon>attach_file</mat-icon>
          Upload file
        </button>

        @if (this.assetManagementService.qrCodeImage) {
          <button class="margin-left-small" color="primary" mat-raised-button (click)="saveQRCode()"
                  data-testid="save-qr-code">
            <mat-icon>save</mat-icon>
            Save QR Code
          </button>
        }
      </div>

    }
  </div>

  <div class="margin-top-med">
    <div class="text-underline">Game Logo:</div>
    @if (gameLogoImageState === CreateImageState.ViewSavedImage) {
      <img [src]="this.assetManagementService.gameLogoUrl" alt="Uploaded Image" style="max-width: 300px;"/>
      <div>
        <button color="primary" mat-raised-button (click)="editGameLogo()" data-testid="confirm-game">
          Change Game Logo
        </button>
      </div>
    } @else if (gameLogoImageState === CreateImageState.NoImageSaved) {
      <input type="file"
             accept=".svg"
             class="file-input display-none"
             (change)="onGameLogoFileSelected($event)" #gameLogoUpload>
      @if (this.assetManagementService.gameLogoImage) {
        <div class="margin-top-med margin-bottom-med">
          <img [src]="this.assetManagementService.gameLogoUrl" alt="Uploaded Image" style="max-width: 300px;"/>
        </div>
      }
      <div class="margin-top-med">
        <button color="primary" mat-raised-button
                (click)="gameLogoUpload.click()">
          <mat-icon>attach_file</mat-icon>
          Upload file
        </button>
        @if (this.assetManagementService.gameLogoImage) {
          <button color="primary" class="margin-left-small" mat-raised-button (click)="saveGameLogo()"
                  data-testid="save-game-logo">
            Save Game Logo
          </button>
        }
      </div>

    }
  </div>

  @if (this.assetManagementService.gameLogoUrl) {
    <mat-toolbar class="sample-header margin-top-large"
                 [style.background-color]="this.assetManagementService.toolbarColor">
      <button mat-icon-button
              class="margin-right-med"
              aria-label="icon for opening the side menu on smaller screens">
        <mat-icon [style.color]="this.assetManagementService.iconColor">menu</mat-icon>
      </button>
      <img [src]="this.assetManagementService.gameLogoUrl" alt="Uploaded Image" style="max-width: 300px;"/>
    </mat-toolbar>

    <mat-form-field appearance="outline" class="full-width margin-top-large">
      <mat-label>Game Theme Type</mat-label>
      <mat-select formControlName="gameThemeTypeId"
                  (valueChange)="onThemeTypeChange($event)">
        <mat-option [value]="GameThemeType.Light">Light</mat-option>
        <mat-option [value]="GameThemeType.Dark">Dark</mat-option>
      </mat-select>
    </mat-form-field>
  }

  <div>
    <mat-label>Primary game Color:</mat-label>
    <ngx-colors ngx-colors-trigger class="color-picker"
                formControlName="primaryGameColor"
                data-testid="primary-game-color-button"
                [acceptLabel]="'CONFIRM'"></ngx-colors>
    {{ newGameAssetsSettingsForm.controls.primaryGameColor.value }}
  </div>

  <div class="margin-top-large">
    <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
      <mat-label>Link for Charities to Join the Fundraiser</mat-label>
      <input matInput
             formControlName="charityRegistrationUrl"
             data-testid="charity-registration-url-input"
             placeholder="https://...">
      <mat-hint>Optional link to the form charities and nonprofits use to ask to join the fundraiser. It appears as a "Register your association" button on the landing page; leave empty to hide it.</mat-hint>
      <mat-error data-testid="new-game-charity-registration-url-error-message" *ngIf="newGameAssetsSettingsForm.controls.charityRegistrationUrl.errors">
        Please enter a valid URL (starting with https://)
      </mat-error>
    </mat-form-field>
  </div>

</form>
